<template>
    <div
        class="is-flex is-multiline is-variable is-1 is-justify-content-center is-align-items-center is-flex-direction-column"
    >
        <p class="mb-4">
            <span class="has-text-weight-semibold">
                Sube tus Libros de Remuneraciones
            </span>
            Mensuales a través de una planilla
        </p>
        <b-button
            type="is-secondary"
            :icon-right="hasUplodedFile ? 'check' : 'upload'"
            @click="modalBookRemunerations()"
            :disabled="!isBookCompleteTransaction || hasUplodedFile"
        >
            <span v-if="isBookCompleteTransaction"
                >Subir Libros de Remuneraciones</span
            >
            <span v-else>Se está validando tu Libro de Remuneraciones</span>
        </b-button>
        <p
            v-if="!isBookCompleteTransaction"
            class="has-text-weight-bold has-text-contrast mt-2"
        >
            Espera a que termine la validación de tu archivo
            <br />
        </p>
        <div v-if="documentHasErrors || isDocumentInvalidBySocket">
            <br />
            <error-notification :msg="errorMsg" :type="errorType" />
        </div>
    </div>
</template>

<script>
// import { checkStatusValidation } from "@/api/s3BookRemunerations";
import BookRemunerations from "@/components/modals/BookRemunerations";
import ErrorNotification from "@/components/obligations/ErrorNotification";
import { mapMutations, mapState } from "vuex";

export default {
    name: "BookRemunerations",
    components: {
        ErrorNotification,
    },
    props: {
        hasUplodedFile: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            book: {},
            errorMsg: null,
            errorType: null,
            sendBook: false,
            modalDefault: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
        };
    },
    computed: {
        ...mapState("bookRemunerations", ["webSocketRemunerations"]),
        documentHasErrors: function() {
            const hasError = this.book.validation_status === "E";
            if (hasError) {
                this.$emit("onUploadBook", false);
                this.updateErrorMsg(this.book.errors);
            }
            return hasError;
        },
        isBookCompleteTransaction: function() {
            return !!this.webSocketRemunerations.responseMessage
                ?.complete_transaction;
        },
        isDocumentValidBySocket: function() {
            return (
                this.webSocketRemunerations.responseMessage
                    ?.validation_status === "V" || false
            );
        },
        isDocumentInvalidBySocket: function() {
            let hasError = false;
            if (
                this.webSocketRemunerations.responseMessage
                    ?.validation_status === "E" &&
                this.webSocketRemunerations.responseMessage?.errors !== ""
            ) {
                hasError = true;
            }
            if (hasError) {
                this.updateErrorMsg(
                    this.webSocketRemunerations.responseMessage.errors
                );
                this.$emit("onUploadBook", false);
            } else {
                if (this.sendBook) {
                    this.$emit("onUploadBook", true);
                }
            }
            return hasError;
        },
    },
    methods: {
        ...mapMutations("bookRemunerations", [
            "SET_WEBSOCKET",
            "SET_TRANSACTION",
        ]),
        updateErrorMsg(msg) {
            this.errorMsg = msg;
            if (msg && "HEADERS_ERRORS" in msg) {
                this.errorType = "HEADERS";
            } else {
                this.errorType = "COLUMNS";
            }
        },
        cleanBookError() {
            this.book.errors = "";
            this.book.validation_status = "P";
            this.sendBook = true;
        },
        modalBookRemunerations() {
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: BookRemunerations,
                props: {
                    book: this.book,
                },
                events: {
                    cleanError: () => {
                        this.cleanBookError();
                    },
                },
            });
        },
    },
    created() {
        this.SET_TRANSACTION({
            complete_transaction: true,
            kind_file: "remuneration",
        });
        this.$emit("onUploadBook", false);
    },
};
</script>
